/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Users_Resend_Invitation_DescriptionInputs */

const en_users_resend_invitation_description = /** @type {(inputs: Users_Resend_Invitation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This resets ${i?.displayName}'s password and multi-factor authentication and emails a new sign-in invitation with a temporary password.`)
};

const pt_br2_users_resend_invitation_description = /** @type {(inputs: Users_Resend_Invitation_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Isso redefine a senha e a autenticação multifator de ${i?.displayName} e envia por e-mail um novo convite de acesso com senha temporária.`)
};

/**
* | output |
* | --- |
* | "This resets {displayName}'s password and multi-factor authentication and emails a new sign-in invitation with a temporary password." |
*
* @param {Users_Resend_Invitation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_resend_invitation_description = /** @type {((inputs: Users_Resend_Invitation_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Resend_Invitation_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_resend_invitation_description(inputs)
	return pt_br2_users_resend_invitation_description(inputs)
});